<template>
<v-layout >
  <!-- :class='mainClasses'  -->
  <v-flex class='pt-0' >
  <v-list dense three-line subheader class='pa-0 ma-0' >
    <template v-for='(message, index) in messages' >
      <v-subheader
        v-if='isNewDate(message, index)' :key='`sub-${message.id}`'
        class='overline grey lighten-4' >{{ dateformat(message.created_date) }}
      </v-subheader>
      <v-divider :key='`dt-div-${message.id}`' ></v-divider>
      <communication-list-item :item='message' v-on='$listeners' />
      <v-divider :key='`div-${message.id}`'></v-divider>
    </template>
  </v-list>
  </v-flex>
</v-layout>

</template>
<script>
import CommunicationListItem from '@/components/listitems/CommunicationListItem.vue'

export default {
  name: 'CommunicationInboxPage',
  components: {CommunicationListItem},
  props: {
    messages: { type: Array, default: () => { return [] } }
  },
  methods: {
    isNewDate (item, index) {
      if (index === 0) { return true }
      let oldDate = new Date(this.messages[index - 1].created_date).toDateString()
      let newDate = new Date(item.created_date).toDateString()
      return (oldDate !== newDate)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Inbox.vue?1e510b33